<template>
  <div>
    <el-dialog
      :title="title"
      :visible.sync="localVisible"
      width="70%"
      :before-close="handleClose"
    >
      <el-form :rules="rules" ref="form" size="small" :model="formData" label-width="100px">
        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item label="属性名称">
              <el-input width="400" placeholder="请输入属性名称"  v-model="addForm.attr_name" type="text"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="输入类型" >
              <el-select
                v-model="addForm.attr_input_type"
                placeholder="请选择剂型"
              >
                <el-option
                  v-for="item in inputList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item label="类型" size="small">
              <el-select width="800" v-model="addForm.cat_id" clearable  placeholder="请选择类型">
                <el-option
                  v-for="item in cateMenus"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" type="primary" @click="onSubmit('form')">确定</el-button>
        <el-button size="small" @click="handleClose">取消</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
  export default {
    name:'eAttr',
    props: {
      visible: {
        type: Boolean,
        default: true,
      },
      formData: {
        type: Object,
        default: null,
      },
      title: {
        type: String,
        default: "",
      },
      closeForm: Function,
    },
    data() {
      return {

        localVisible:false,
        addForm:{
          attr_id:'',
          attr_name:'',
          attr_input_type:'',
          cat_id:'',
        },
        inputList:[{id:1,name:'选择输入'},{id:0,name:'手工输入'},],
        cateMenus:[],

        memberLoading:'',
        memberList:[],
        memberStates:[],

        lng_lat:'',

        areaList: [],

        rules: {

        },
        curShop: '',
        employee_id: '',
        name_cn: '',

        keywords: '',
        fileList: [],
        mList: [],
        pageNum: 1,
        pageSize: 10,
        isResouceone: false,

      }
    },
    mounted() {
      ///this.getList();
      this.getCateMenus();
    },
    methods:{
      getCateMenus(){
        let _this = this;
        let params={
          access_token:sessionStorage.getItem('token'),
          company_id:sessionStorage.getItem('company_id'),
          shop_id:sessionStorage.getItem('shop_id')
        };
        this.$axios.goodsTypeTable(params).then((res)=>{
          if(res.code == 200) {
            _this.cateMenus=res.data;
          }
        });

      },
      handleChangeAddress(row){     // 更改时调用
        console.log(row)
        let _this=this;
        const checkedNode =  this.$refs["cascaderAddr"].getCheckedNodes();
        _this.formData.province_id=checkedNode[0].path[0];
        _this.formData.city_id=checkedNode[0].path[1];
        _this.formData.district_id=checkedNode[0].path[2];
      },
      // 关闭
      handleClose() {
        //this.$refs["form"].resetFields();
        this.closeForm();
      },
      // 前置提交
      onSubmit(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            this.submit();
          } else {
            return false;
          }
        });
      },
      submit() {
        let params=this.addForm;
        params.company_id=sessionStorage.getItem('company_id');
        params.access_token=sessionStorage.getItem('token');
        params.shop_id=sessionStorage.getItem('shop_id');

        this.$axios.goodsAttributesSave(params).then(res=>{
          if(res.code == 200){
            this.$message.success("保存成功");
            this.closeForm();
          }
        }).catch(error=>{
          this.$message.error("保存错误");
          console.log(error);
        })
      },

      getList(){
        const param = {
          company_id:sessionStorage.getItem('company_id'),
          access_token:sessionStorage.getItem('token'),
          pageNum: this.pageNum,
          pageSize: this.pageSize,
        }
        this.$axios.employeeList(param).then(res=>{
          if(res.code == 200){
            this.mList = res.data.data
            this.total = res.data.total
          }
        }).catch(error=>{
          console.log(error);
        })
      },
      clickChange(row){
        this.employee_id=row.id;
        this.name_cn=row.name_cn;
        console.log('row----',row);
      },
      handleBeforeUpload(){

      },
      uploadSuccess(){

      },
      uploadFile(){

      },
      chooseItem(){

      },

      memberRemoteMethod(query){
        if (query !== '') {
          this.memberLoading = true;
          let param={
            keyword:query,
            operator_id:sessionStorage.getItem('user_id'),
            company_id:sessionStorage.getItem('company_id'),
            access_token:sessionStorage.getItem('token'),
          }
          this.$axios.posMemberListP(param).then(res=>{
            if(res.code == 200){
              this.memberStates = res.data.data;
            }
          }).catch(error=>{
              console.log(error);
          })
          setTimeout(() => {
            this.memberLoading = false;
            this.memberList = this.memberSet.filter(item => { // 这里的this.list，换为this.applicantSet
              return item.name;
            });
          }, 1000);
        } else {
          this.memberList = [];
        }
      },
    },
    computed: {
      memberSet() {
        return this.memberStates.map(item => {
          return {id: `${item.id}`, name: `${item.merchant_name}`};
        });
      },
    },
    // 监听
    watch: {
     async visible(val) {
       this.localVisible=val;
        console.log('----val----',val)
        if (val) {
          this.addForm.attr_name=this.formData.attr_name;
          this.addForm.attr_input_type=this.formData.attr_input_type;
          this.addForm.cat_id=this.formData.cat_id;
          this.addForm.attr_id=this.formData.attr_id;
          console.log('this.addForm',this.addForm)
          // if (this.formData.img) {
          //   console.log(this.formData, " this.formData");
          //   this.formData.img = [
          //     {
          //       name: this.formData.img,
          //       url: this.formData.img,
          //     },
          //   ];
          // }
        }
      },
    },
  }
</script>
<style lang="less" scoped>
  //https://www.yzktw.com.cn/post/1262748.html
  .upload_group {
    width: 100%;
    display: flex;
    justify-content: flex-start;
    align-items: center;

    .upload_list {
      width: 120px;
      margin-right: 1rem;
    }

    /deep/.el-upload-dragger .el-upload__text {
      font-size: 10px;
      color: #409EFF;
    }

    /deep/.el-icon-upload:before {
      width: 40px !important;
      height: 40px !important;
    }

    .upload_list:last-child {
      margin-right: 0;
    }

    /deep/.el-upload-dragger {
      width: 100%;
      height: auto;
      padding: 20px 0;
      border: 1px solid #999;
    }

    /deep/.el-upload {
      width: 100%;
    }

    /deep/.el-upload-dragger .el-icon-upload {
      margin: 10px 0;
    }
  }
  .table_name:hover{
    color: #409EFF;
    cursor: pointer;
  }
</style>
